import { defineComponent as g, computed as p, h as s } from "vue";
import b from "./ghl-ui.es1338.js";
import { useMenuChild as v } from "./ghl-ui.es1339.js";
import { useMenuChildProps as C } from "./ghl-ui.es1340.js";
import m from "./ghl-ui.es690.js";
import x from "./ghl-ui.es378.js";
import { render as M } from "./ghl-ui.es950.js";
const N = Object.assign(Object.assign({}, C), {
  tmNode: {
    type: Object,
    required: !0
  },
  disabled: Boolean,
  icon: Function,
  onClick: Function
}), k = g({
  name: "MenuOption",
  props: N,
  setup(e) {
    const i = v(e), {
      NSubmenu: n,
      NMenu: t
    } = i, {
      props: o,
      mergedClsPrefixRef: r,
      mergedCollapsedRef: c
    } = t, u = n ? n.mergedDisabledRef : {
      value: !1
    }, d = p(() => u.value || e.disabled);
    function f(l) {
      const {
        onClick: a
      } = e;
      a && a(l);
    }
    function h(l) {
      d.value || (t.doSelect(e.internalKey, e.tmNode.rawNode), f(l));
    }
    return {
      mergedClsPrefix: r,
      dropdownPlacement: i.dropdownPlacement,
      paddingLeft: i.paddingLeft,
      iconMarginRight: i.iconMarginRight,
      maxIconSize: i.maxIconSize,
      activeIconSize: i.activeIconSize,
      mergedTheme: t.mergedThemeRef,
      menuProps: o,
      dropdownEnabled: m(() => e.root && c.value && o.mode !== "horizontal" && !d.value),
      selected: m(() => t.mergedValueRef.value === e.internalKey),
      mergedDisabled: d,
      handleClick: h
    };
  },
  render() {
    const {
      mergedClsPrefix: e,
      mergedTheme: i,
      tmNode: n,
      menuProps: {
        renderLabel: t,
        nodeProps: o
      }
    } = this, r = o == null ? void 0 : o(n.rawNode);
    return s("div", Object.assign({}, r, {
      role: "menuitem",
      class: [`${e}-menu-item`, r == null ? void 0 : r.class]
    }), s(x, {
      theme: i.peers.Tooltip,
      themeOverrides: i.peerOverrides.Tooltip,
      trigger: "hover",
      placement: this.dropdownPlacement,
      disabled: !this.dropdownEnabled || this.title === void 0,
      internalExtraClass: ["menu-tooltip"]
    }, {
      default: () => t ? t(n.rawNode) : M(this.title),
      trigger: () => s(b, {
        tmNode: n,
        clsPrefix: e,
        paddingLeft: this.paddingLeft,
        iconMarginRight: this.iconMarginRight,
        maxIconSize: this.maxIconSize,
        activeIconSize: this.activeIconSize,
        selected: this.selected,
        title: this.title,
        extra: this.extra,
        disabled: this.mergedDisabled,
        icon: this.icon,
        onClick: this.handleClick
      })
    }));
  }
});
export {
  k as NMenuOption,
  N as menuItemProps
};
